import { useState, useEffect } from 'react';
import fetchCsrfToken from './fetchCsrfToken';

const useCsrfToken = () => {
  const [csrfToken, setCsrfToken] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await fetchCsrfToken();

        setCsrfToken(token);
      } catch (err) {
        console.error('Error fetching CSRF token:', err);
        setError(err.message);
      }
    };

    fetchToken();
  }, []);

  return { csrfToken, error };
};

export default useCsrfToken;
